import { cn } from '@/src/lib/utils'
import { ImSpinner8 } from 'react-icons/im'

const Spinner = ({ className, size }: { className?: string; size?: number }) => (
  <ImSpinner8 size={size} className={cn('animate-spin', className)} />
)

export default Spinner
